import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import LicensesInUseList from "../Components/LicensesInUseList";
import ButtonBack from "../Components/ButtonBack";

class LicensesInUseListPage extends Component {

    render() {
        const { stores, customerId } = this.props;

        let customerName = "";
        const customer = stores.data.CustomersStore.findById(customerId);
        if (customer) customerName = customer.Name;

        const licensesInUse = stores.data.LicensesInUseStore._data;

        return (
            <div>
                <div className="row">
                    <ButtonBack />
                </div>

                <div className="row">
                    <h1>Licences in use - {customerName}</h1>
                </div>

                <div className="row">
                    <LicensesInUseList licensesInUse={licensesInUse} />
                </div>
            </div>
        );
    }
}

export default inject("stores")(observer(LicensesInUseListPage));



// WEBPACK FOOTER //
// ./src/Pages/LicensesInUseListPage.js